module.exports = __webpack_public_path__ + "media/red_checkmark.0fdc5a1c.webm";